import styled from '@emotion/styled';

export default styled.h2`
  font-size: 40px;
  font-weight: 700;
  font-family: Helvetica, sans-serif;
  color: #325882;
`;
